var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    fill: "#1467C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 58.75L49.6875 49.6875M54.5833 37.9167C54.5833 47.1214 47.1214 54.5833 37.9167 54.5833C28.7119 54.5833 21.25 47.1214 21.25 37.9167C21.25 28.7119 28.7119 21.25 37.9167 21.25C47.1214 21.25 54.5833 28.7119 54.5833 37.9167Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicn);
export default __webpack_public_path__ + "static/media/searchicn.fba872aeb7dcec615221fdef434899f6.svg";
export { ForwardRef as ReactComponent };